import AuthBootstrap from "@/components/auth/AuthBootstrap";
import { useVersionCheck } from "@medicorepay/shared/lib/use-version-check";
import { VersionBanner } from "@medicorepay/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const versionCheck = useVersionCheck({
    apiBaseUrl: import.meta.env.VITE_API_URL || "http://localhost:5001",
    clientVersion: import.meta.env.VITE_APP_VERSION || "1.0.0",
    platform: "admin",
  });

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <VersionBanner
          status={versionCheck.status}
          message={versionCheck.message}
          clientVersion={versionCheck.clientVersion}
          apiVersion={versionCheck.apiVersion}
          onDismiss={() => {}}
        />
        <Toaster position="top-right" />
        <AuthBootstrap />
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
